import React from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
  Phone,
} from "lucide-react";
import logo from "../../assets/image/logo1.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navigation = {
    main: [
      { name: "Home", href: "/" },
      { name: "About", href: "/about" },
      { name: "Services", href: "/services" },
      { name: "Contact", href: "/contact" },
      { name: "Privacy Policy", href: "/privacy-policy" },
      { name: "Terms & Conditions", href: "/terms-and-conditions" },
    ],
    services: [
      { name: "Commercial Cleaning", href: "/services#commercial" },
      { name: "Residential Cleaning", href: "/services#residential" },
      { name: "Industrial Cleaning", href: "/services#industrial" },
      { name: "Specialized Cleaning", href: "/services#specialized" },
    ],
    social: [
      {
        name: "Facebook",
        href: "https://www.facebook.com/share/1DY3FKLavf/?mibextid=wwXIfr",
        icon: Facebook,
      },
      {
        name: "Instagram",
        href: "https://www.instagram.com/invites/contact/?i=1q2iwwe4b29x8&utm_content=uilkl3c",
        icon: Instagram,
      },
      {
        name: "LinkedIn",
        href: "#",
        icon: Linkedin,
      },
      {
        name: "TikTok",
        href: "https://www.tiktok.com/@envipro.solutions?_t=ZS-8tHdbJFDRa6&_r=1",
        icon: () => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05 6.33 6.33 0 0 0-4.27 1.89 6.21 6.21 0 0 0-1.55 4.46c.07 2.12.74 3.78 2.2 4.78a6.3 6.3 0 0 0 3.55 1.13c.66 0 1.32-.1 1.98-.3a6.31 6.31 0 0 0 3.26-2.23 6.18 6.18 0 0 0 1.21-3.74v-6.7a8.09 8.09 0 0 0 4.97 1.89V7.5a4.28 4.28 0 0 1-2.5-1.26z" />
          </svg>
        ),
      },
    ],
  };

  return (
    <footer className="bg-gray-900" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img className="h-12" src={logo} alt="Envipro Solutions" />
            <p className="mt-6 text-base text-gray-300">
              Professional cleaning services you can trust. Making Australia
              cleaner, one space at a time.
            </p>
            <div className="mt-6 space-y-4">
              <div className="flex items-center">
                <Phone className="h-5 w-5 text-primary" />
                <span className="ml-3 text-gray-300">
                  Mob : 0452298814 <br />Tel : 0882708801
                </span>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 text-primary" />
                <span className="ml-3 text-gray-300">
                  info@enviprosolutions.com.au
                </span>
              </div>
              <div className="flex items-center">
                <MapPin className="h-5 w-5 text-primary" />
                <span className="ml-3 text-gray-300">Australia</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Quick Links
            </h3>
            <ul role="list" className="mt-4 space-y-4">
              {navigation.main.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-300 hover:text-white"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Our Services
            </h3>
            <ul role="list" className="mt-4 space-y-4">
              {navigation.services.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-300 hover:text-white"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Subscribe to our newsletter
            </h3>
            <p className="mt-4 text-base text-gray-300">
              Get the latest updates and special offers delivered directly to
              your inbox.
            </p>
            <form className="mt-4">
              <div className="flex space-x-2">
                <input
                  type="email"
                  className="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                  placeholder="Enter your email"
                />
                <button
                  type="submit"
                  className="flex-none rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                >
                  Subscribe
                </button>
              </div>
            </form>

            {/* Social Links */}
            <div className="mt-6">
              <div className="flex space-x-6">
                {navigation.social.map((item) => {
                  const IconComponent = item.icon;
                  return (
                    <a
                      key={item.name}
                      href={item.href}
                      className="text-gray-400 hover:text-gray-300"
                    >
                      <span className="sr-only">{item.name}</span>
                      <IconComponent className="h-6 w-6" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-gray-800 pt-8">
          <p className="text-base text-gray-400 text-center">
            © {currentYear} SUMEDHA LAKMAL CREATION. All rights reserved.
          </p>
          {/* <Link
            to="/privacy-policy"
            className="text-sm text-gray-400 hover:text-white"
          >
            Privacy Policy
          </Link> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
